var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          staticClass: "invoice-preview-modal",
          attrs: { width: 1000, title: "预览发票" },
          model: {
            value: _vm.preViewModal.show,
            callback: function ($$v) {
              _vm.$set(_vm.preViewModal, "show", $$v)
            },
            expression: "preViewModal.show",
          },
        },
        [
          _c(
            "div",
            { staticClass: "invoice-container" },
            [
              _c("div", { staticClass: "header-row" }, [
                _c("div", { staticClass: "w-330" }),
                _c("div", { staticClass: "invoice-title" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.isDigital ? "（电子发票）" : "") +
                      "增值税虚拟发票\n                "
                  ),
                ]),
                _c("div", { staticClass: "w-330 text-right" }, [
                  _c("span", [_vm._v("开票日期:")]),
                  _c("span", { staticClass: "text-black ml-4" }, [
                    _vm._v(_vm._s(_vm.currentDate)),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "info-box-wrapper" }, [
                _c("div", { staticClass: "flex-center" }, [
                  _c(
                    "div",
                    { staticClass: "vertical-text invoiceBorder side-label" },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.isDigital ? "购买方信息" : "购买方") +
                          "\n                    "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "invoiceBorder info-content" },
                    [
                      _c("div", [
                        _c("span", { staticClass: "label-justify" }, [
                          _vm._v("名    称:"),
                        ]),
                        _c("span", { staticClass: "text-black ml-4" }, [
                          _vm._v(
                            _vm._s(
                              _vm.preViewModal.invoiceModel.invoiceBuyerName
                            )
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("span", [_vm._v("纳税人识别号:")]),
                        _c("span", { staticClass: "text-black ml-4" }, [
                          _vm._v(
                            _vm._s(
                              _vm.preViewModal.invoiceModel.invoiceBuyerTaxNum
                            )
                          ),
                        ]),
                      ]),
                      !_vm.isDigital
                        ? [
                            _c("div", [
                              _c("span", [_vm._v("地址 、电话:")]),
                              _c("span", { staticClass: "text-black ml-4" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.preViewModal.invoiceModel
                                        .invoiceBuyerAddress
                                    ) +
                                    "\n                                    " +
                                    _vm._s(
                                      _vm.preViewModal.invoiceModel
                                        .invoiceBuyerTel
                                    ) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                            _c("div", [
                              _c("span", [_vm._v("开户行及账号:")]),
                              _c("span", { staticClass: "text-black ml-4" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.preViewModal.invoiceModel
                                        .invoiceBuyerBank
                                    ) +
                                    "\n                                    " +
                                    _vm._s(
                                      _vm.preViewModal.invoiceModel
                                        .invoiceBuyerAccount
                                    ) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "vertical-text invoiceBorder side-label" },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.isDigital ? "销售方信息" : "密码区") +
                          "\n                    "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "invoiceBorder info-content" },
                    [
                      _vm.isDigital
                        ? [
                            _c("div", [
                              _c("span", { staticClass: "label-justify" }, [
                                _vm._v("名    称:"),
                              ]),
                              _c("span", { staticClass: "text-black ml-4" }, [
                                _vm._v(_vm._s(_vm.companyName)),
                              ]),
                            ]),
                            _c("div", [
                              _c("span", [_vm._v("纳税人识别号:")]),
                              _c("span", { staticClass: "text-black ml-4" }, [
                                _vm._v(_vm._s(_vm.preViewModal.salerTaxNum)),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]),
              !_vm.isDigital
                ? _c("div", { staticClass: "info-box-wrapper border-top-0" }, [
                    _c("div", { staticClass: "flex-center" }, [
                      _c(
                        "div",
                        {
                          staticClass: "vertical-text invoiceBorder side-label",
                        },
                        [
                          _vm._v(
                            "\n                        销售方\n                    "
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "invoiceBorder info-content" }, [
                        _c("div", [
                          _c("span", { staticClass: "label-justify" }, [
                            _vm._v("名    称:"),
                          ]),
                          _c("span", { staticClass: "text-black ml-4" }, [
                            _vm._v(_vm._s(_vm.companyName)),
                          ]),
                        ]),
                        _c("div", [
                          _c("span", [_vm._v("纳税人识别号:")]),
                          _c("span", { staticClass: "text-black ml-4" }, [
                            _vm._v(_vm._s(_vm.preViewModal.salerTaxNum)),
                          ]),
                        ]),
                        _c("div", [
                          _c("span", [_vm._v("地址 、电话:")]),
                          _c("span", { staticClass: "text-black ml-4" }, [
                            _vm._v(_vm._s(_vm.preViewModal.salerAddress)),
                          ]),
                        ]),
                        _c("div", [
                          _c("span", [_vm._v("开户行及账号:")]),
                          _c("span", { staticClass: "text-black ml-4" }, [
                            _vm._v(_vm._s(_vm.preViewModal.bankInfo)),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "vertical-text invoiceBorder side-label",
                        },
                        [
                          _vm._v(
                            "\n                        备注\n                    "
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "invoiceBorder info-content" }),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "table-row table-header" }, [
                _c("div", { staticClass: "invoiceBorder cell-name" }, [
                  _vm._v("项目名称"),
                ]),
                _c("div", { staticClass: "invoiceBorder cell-std" }, [
                  _vm._v("规格型号"),
                ]),
                _c("div", { staticClass: "invoiceBorder cell-std" }, [
                  _vm._v("单位"),
                ]),
                _c("div", { staticClass: "invoiceBorder cell-std" }, [
                  _vm._v("数量"),
                ]),
                _c("div", { staticClass: "invoiceBorder cell-std" }, [
                  _vm._v("单价"),
                ]),
                _c("div", { staticClass: "invoiceBorder cell-std" }, [
                  _vm._v("金额"),
                ]),
                _c("div", { staticClass: "invoiceBorder cell-std" }, [
                  _vm._v("税率"),
                ]),
                _c("div", { staticClass: "invoiceBorder cell-std" }, [
                  _vm._v("税额"),
                ]),
              ]),
              _vm._l(_vm.preViewModal.productList, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "table-row text-black" },
                  [
                    _c("div", { staticClass: "invoiceBorder cell-name" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.productName) +
                          "\n                "
                      ),
                    ]),
                    _c("div", { staticClass: "invoiceBorder cell-std" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.productSpec) +
                          "\n                "
                      ),
                    ]),
                    _c("div", { staticClass: "invoiceBorder cell-std" }, [
                      _vm._v(_vm._s(item.unit)),
                    ]),
                    _c("div", { staticClass: "invoiceBorder cell-std" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.quantity) +
                          "\n                "
                      ),
                    ]),
                    _c("div", { staticClass: "invoiceBorder cell-std" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.numberToFixed(item.price, 4)) +
                          "\n                "
                      ),
                    ]),
                    _c("div", { staticClass: "invoiceBorder cell-std" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.numberToFixed(item.value, 4)) +
                          "\n                "
                      ),
                    ]),
                    _c("div", { staticClass: "invoiceBorder cell-std" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.taxRate * 100) +
                          "%\n                "
                      ),
                    ]),
                    _c("div", { staticClass: "invoiceBorder cell-std" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.numberToFixed(item.taxValue, 4)) +
                          "\n                "
                      ),
                    ]),
                  ]
                )
              }),
              _c("div", { staticClass: "table-row text-black" }, [
                _c(
                  "div",
                  { staticClass: "invoiceBorder cell-name text-theme" },
                  [_vm._v("合计")]
                ),
                _c("div", { staticClass: "invoiceBorder cell-std" }),
                _c("div", { staticClass: "invoiceBorder cell-std" }),
                _c("div", { staticClass: "invoiceBorder cell-std" }),
                _c("div", { staticClass: "invoiceBorder cell-std" }),
                _c("div", { staticClass: "invoiceBorder cell-std" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.numberToFixed(_vm.preViewModal.totalValue, 4)
                      ) +
                      "\n                "
                  ),
                ]),
                _c("div", { staticClass: "invoiceBorder cell-std" }),
                _c("div", { staticClass: "invoiceBorder cell-std" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.numberToFixed(_vm.preViewModal.totalTax, 4)) +
                      "\n                "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "table-row text-black" }, [
                _c(
                  "div",
                  { staticClass: "invoiceBorder cell-name text-theme" },
                  [
                    _vm._v(
                      "\n                    价税合计(大写)\n                "
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "invoiceBorder cell-total-lg flex-between" },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.smalltoBIG(
                            _vm.preViewModal.invoiceModel.invoiceValue
                          )
                        )
                      ),
                    ]),
                    _c("div", [
                      _c("span", { staticClass: "text-theme" }, [
                        _vm._v("（小写）"),
                      ]),
                      _c("span", [
                        _vm._v(
                          "￥" +
                            _vm._s(
                              _vm.numberToFixed(
                                _vm.preViewModal.invoiceModel.invoiceValue,
                                2
                              )
                            )
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]),
              _vm.isDigital
                ? _c("div", { staticClass: "info-box-wrapper border-top-0" }, [
                    _c("div", { staticClass: "flex-center" }, [
                      _c(
                        "div",
                        {
                          staticClass: "vertical-text invoiceBorder side-label",
                        },
                        [
                          _vm._v(
                            "\n                        备注\n                    "
                          ),
                        ]
                      ),
                      _c("div", {
                        staticClass: "invoiceBorder cell-remark-wide",
                      }),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "footer-row" },
                [
                  _vm.isDigital
                    ? [
                        _c("div", { staticClass: "w-250" }, [
                          _c("span", [_vm._v("开票人:")]),
                          _c("span", { staticClass: "text-black ml-4" }, [
                            _vm._v(_vm._s(_vm.preViewModal.clerk)),
                          ]),
                        ]),
                      ]
                    : [
                        _c("div", { staticClass: "w-250" }, [
                          _c("span", [_vm._v("收款人:")]),
                          _c("span", { staticClass: "text-black ml-4" }, [
                            _vm._v(_vm._s(_vm.preViewModal.payee)),
                          ]),
                        ]),
                        _c("div", { staticClass: "w-250" }, [
                          _c("span", [_vm._v("复核:")]),
                          _c("span", { staticClass: "text-black ml-4" }, [
                            _vm._v(_vm._s(_vm.preViewModal.checker)),
                          ]),
                        ]),
                        _c("div", { staticClass: "w-250" }, [
                          _c("span", [_vm._v("开票人:")]),
                          _c("span", { staticClass: "text-black ml-4" }, [
                            _vm._v(_vm._s(_vm.preViewModal.clerk)),
                          ]),
                        ]),
                        _c("div", { staticClass: "w-250" }, [
                          _c("span", [_vm._v("销售方:")]),
                          _c("span", [_vm._v("（章）")]),
                        ]),
                      ],
                ],
                2
              ),
            ],
            2
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { loading: _vm.preViewModal.loading, type: "primary" },
                  on: { click: _vm.onConfirmApplyInvoice },
                },
                [_vm._v("提交开票")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }